import { useMemo } from 'react';

import { PaymentProviderName } from 'domain/paySettings/helpers';
import { getBankAccountsAction, getPayingProvidersAction } from 'domain/paySettings';
import useDispatchAction from 'hooks/useDispatchAction';

import { globalAccountsConfig } from '../config';

type UseGlobalAccountFormContext = {
  providerName: PaymentProviderName;
  providerId: string;
  bankAccounts?: Array<{ value: string; label: string }>;
};

export const useGlobalAccountFormContext = ({
  providerName,
  providerId,
  bankAccounts = [],
}: UseGlobalAccountFormContext) => {
  const config = globalAccountsConfig[providerName];
  const payload = useMemo(() => ({ id: providerId }), [providerId]);

  const { data: bankAccountsData = [], isLoading: isLoadingBankAccounts } = useDispatchAction(
    getBankAccountsAction,
    payload,
    bankAccounts,
    !bankAccounts.length && config?.dataRequirements?.includes('bankAccounts'),
  );

  const { data: payingProviders = [], isLoading: isLoadingPayingProviders } = useDispatchAction(
    getPayingProvidersAction,
    payload,
    [],
    Boolean(config?.dataRequirements?.includes('payingProviders')),
  );

  return {
    isLoading: isLoadingBankAccounts || isLoadingPayingProviders,
    context: {
      bankAccounts: bankAccountsData,
      payingProviders,
    },
  };
};
